export default __webpack_public_path__ + "static/media/host_notes_icon_white.9920d5c7.svg";